import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { Profile } from "@/models/Profile.model";
import { useUsersStore } from "@/store/admin/users/Users.store";

export const useUsers = () => {
  const { users, setUsers } = useUsersStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);

    try {
      await collectionRef.Profiles.get().then((querySnapshot) => {
        const data: Profile[] = [];
        querySnapshot.forEach((doc) => {
          const variation = doc.data() as Profile;
          const job = {
            ...variation,
            id: doc.id,
          } as Profile;
          data.push(job);
        });
        setUsers(data);
        setLoading(false);
      });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!users) {
      fetchData();
    }
  }, [users]);

  return {
    data: users,
    loading,
    error,
  };
};
